export const EV2_A = `### 费率计划：EV2-A

无分级；分时计费，适用于拥有电动汽车的住宅用户。[更多信息。](https://www.pge.com/en_US/residential/rate-plans/rate-plan-options/electric-vehicle-base-plan/electric-vehicle-base-plan.page)

家庭充电 EV2-A 费率计划的成本在每天（包括周末和节假日）需求最低的凌晨 12 点至下午 3 点之间最低，因此这是为车辆充电的最佳时间。在高峰时段（下午 4 点至晚上 9 点）和次高峰时段（下午 3 点至 4 点以及晚上 9 点至凌晨 12 点）电费较贵。

家庭充电 EV2-A 费率计划自 2026 年 3 月起包含基本服务费并降低了每千瓦时 (kWh) 的价格。请访问 [pge.com/baseservicescharge](https://www.pge.com/baseservicescharge) 了解更多信息。

#### 可能受益的客户

该费率计划适用于拥有电动汽车 (EV) 和/或电池储能设备，并能在凌晨 12 点至下午 3 点的非高峰时段充电，且能将其他家庭用电转移到非高峰时段的客户。

#### 描述

此费率计划同时适用于家庭用电以及电动汽车和/或电池充电。

它在能源供应成本较低的时段提供更低的价格。

#### 注意事项

避免在高峰时段充电。为了最大限度地节省开支，请考虑将其他家庭用电转移到价格较低、需求较低的时段（见上图）。

在过去 12 个月中用电量极高（超过基准量 800%）的客户不符合此费率条件。

[了解更多关于家庭充电 EV2-A 费率计划的信息](https://www.pge.com/en/account/rate-plans/electric-vehicles.html#ev2adetails)`;

export const E_ELEC = `### 费率计划：E-ELEC

PG&E 为全电能房屋提供的费率计划。[更多信息。](https://www.pge.com/en_US/residential/rate-plans/rate-plan-options/electric-home-rate-plan.page)

全电家庭费率计划 (E-ELEC) 非常适合已开始通过以下一项或多项设备实现家庭电气化的客户：电动汽车 (EV)、电池储能、热泵空间调节或热泵热水器。

全电家庭费率计划 (E-ELEC) 自 2026 年 3 月起包含基本服务费并降低了每千瓦时 (kWh) 的价格。请访问 [pge.com/baseservicescharge](https://www.pge.com/baseservicescharge) 了解更多信息。

#### 运作方式

您支付的价格根据时段而变化：
- 高峰（最高价）- 下午 4 点至晚上 9 点
- 次高峰 - 下午 3 点至 4 点，以及晚上 9 点至凌晨 12 点
- 非高峰（最低价）- 凌晨 12 点至下午 3 点

与其他费率不同，该费率不设分级，且每周 7 天执行。

#### 对您的意义
 
- 如果您是用电大户，且能将用电转移到价格较低的时段，该费率计划可能会为您节省开支。
- 您的房屋不需要完全实现电气化也有资格申请此费率计划。

[了解更多关于全电家庭费率计划 (E-ELEC) 的信息](https://www.pge.com/en/account/billing-and-assistance/base-services-charge.html)`;

export const EV_B = `### 费率计划：EV-B

无分级；分时计费，适用于拥有电动汽车的住宅用户。该费率计划涉及安装另一个电表，将您的电动汽车充电费用与家庭用电费用分开。[更多信息。](https://www.pge.com/tariffs/assets/pdf/tariffbook/ELEC_SCHEDS_EV%20(Sch).pdf)

EV-B 的成本在需求最低的晚上 11 点至早上 7 点之间最低，因此这是为车辆充电的最佳时间。在高峰时段（下午 2 点至晚上 9 点）和次高峰时段（早上 7 点至下午 2 点以及晚上 9 点至 11 点）电费较贵。

#### 可能受益的客户

希望通过专用电表将电动汽车充电与家庭用电分开记录的客户。如果您能在工作日的早上 7 点至晚上 11 点，以及周末和节假日的下午 3 点至晚上 7 点减少用电量，该费率计划可能最适合您。

#### 描述

双电表：一个用于家庭用电，另一个用于电动汽车充电。充电价格随全天时段变化。您的家庭用电量将单独计量。

#### 注意事项

避免在高峰时段充电。安装第二个电表的成本可能较高。每个电表需支付一次性 100 美元的费用，外加安装充电站和第二个配电盘的费用。可能还需要进行电力服务升级。视现场情况而定，费用通常在 2,000 美元左右，最高可达 8,000 美元左右。

收费标准

| 总能源费率（每 kWh 美元） | 夏季 | 冬季 |
| --- | --- | --- |
| 高峰 | $0.60057 | $0.41855 |
| 次高峰 | $0.35646 | $0.28654 |
| 非高峰 | $0.24391 | $0.21481 |

总电表费：每天 $0.04928。

请参阅[此处](https://www.pge.com/tariffs/assets/pdf/tariffbook/ELEC_SCHEDS_EV%20(Sch).pdf)查看时段定义和收费详情。`;

export const E_1 = `### 费率计划：E-1

PG&E 的分级费率计划。[更多信息。](https://www.pge.com/en_US/residential/rate-plans/rate-plan-options/tiered-base-plan/tiered-base-plan.page)

此费率计划有两个价格级别，称为“分级”，根据您的用电量而定。

分级费率计划 (E-1) 自 2026 年 3 月起包含基本服务费并降低了每千瓦时 (kWh) 的价格。请访问 [pge.com/baseservicescharge](https://www.pge.com/baseservicescharge) 了解更多信息。

#### 了解基准量 (Baseline Allowance)

第一级也是价格最低的一级被称为您的基准量。它根据您的居住地、供暖来源以及季节（夏季或冬季）分配一定的电量。夏季为 5 月 1 日至 10 月 31 日，冬季为 11 月 1 日至 4 月 30 日。

- 在基准量范围内的用电按最低价格计费。
- 超过基准量的用电被视为第 2 级，并按较高价格计费。

[查找您的基准量。](https://www.pge.com/en_US/residential/rate-plans/rate-plan-options/tiered-base-plan/understanding-baseline-allowance.page)

[了解更多关于分级费率计划 (E-1) 的信息](https://www.pge.com/en/account/rate-plans/tiered-rate-plan.html)`;

export const E_TOU_C = `### 费率计划：E-TOU-C

分时计费，每天下午 4 - 9 点为高峰时段 (E-TOU-C) 费率计划。[更多信息](https://www.pge.com/en_US/residential/rate-plans/rate-plan-options/time-of-use-base-plan/tou-everyday.page)

该费率计划在每天下午 4 点之前和晚上 9 点之后提供较低的价格（非高峰）。

每天下午 4 - 9 点高峰定价 (E-TOU-C) 自 2026 年 3 月起包含基本服务费并降低了每千瓦时 (kWh) 的价格。请访问 [pge.com/baseservicescharge](https://www.pge.com/baseservicescharge) 了解更多信息。

#### 运作方式：

您支付的价格根据时段而变化

-   高峰（较高价格）-- 每天下午 4 点至晚上 9 点
-   非高峰（较低价格）-- 每天下午 4 点之前和晚上 9 点之后

#### 对您的意义：

-   如果您能减少总体用电量，尤其是减少高价（高峰）时段的用电，就可以节省开支。

[了解更多关于每天下午 4 - 9 点高峰定价 (E-TOU-C) 费率计划的信息。](https://www.pge.com/en_US/residential/rate-plans/rate-plan-options/time-of-use-base-plan/tou-everyday.page)`;

export const E_TOU_D = `### 费率计划：E-TOU-D

分时计费，工作日下午 5 - 8 点为高峰时段 (E-TOU-D) 费率计划。[更多信息。](https://www.pge.com/en_US/residential/rate-plans/rate-plan-options/time-of-use-base-plan/time-of-use-plan.page)

该费率计划在能源成本较低的时段提供较低价格——即工作日下午 5 点之前和晚上 8 点之后，以及周末和大多数节假日的全部时段。

工作日下午 5 - 8 点高峰定价 (E-TOU-D) 费率计划自 2026 年 3 月起包含基本服务费并降低了每千瓦时 (kWh) 的价格。请访问 [pge.com/baseservicescharge](https://www.pge.com/baseservicescharge) 了解更多信息。

#### 运作方式：

您支付的价格根据时段、星期几和季节而变化

-   高峰（最高价格）-- 周一至周五下午 5 点至晚上 8 点（大多数节假日除外）
-   非高峰（最低价格）-- 周一至周五下午 5 点之前和晚上 8 点之后，以及周末和大多数节假日的全部时段

-   其中八个月（10 月至 5 月）的价格低于夏季的四个月（6 月至 9 月）。
-   与每天下午 4 - 9 点高峰定价 (E-TOU-C) 费率计划不同，此费率计划没有基准量 (Baseline Allowance)。

#### 对您的意义：

-   如果您能减少总体用电量，尤其是减少高价（高峰）时段的用电，您就有机会节省开支。
-   对于高用电量客户，工作日下午 5 - 8 点高峰定价 (E-TOU-D) 费率计划可能更具吸引力，因为一旦您的每月用电量超过第 1 级金额（基准量），其电价将低于每天下午 4 - 9 点高峰定价 (E-TOU-C) 费率计划。

[了解更多关于工作日下午 5 - 8 点高峰定价 (E-TOU-D) 费率计划的信息](https://www.pge.com/en_US/residential/rate-plans/rate-plan-options/time-of-use-base-plan/tou-weekdays.page)`;
